import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CatalogService } from '@catalog/catalog.service';
import { ToastrService } from 'ngx-toastr';
import { JobData } from './../catalouge-careers.model';
import { ConfirmationDialogComponent } from '@common/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { ErrorHandler } from '@root/utils/error-handler.service';
@Component({
  selector: 'app-list-job',
  templateUrl: './list-job.component.html',
  styleUrls: ['./list-job.component.scss'],
  providers: [CatalogService],
})
export class ListJobComponent implements OnInit {
  private materPostedJobList: any[];

  public postedJobList: any[];

  public locations: string[];

  public departments: string[];

  panelMap: { [key: string]: boolean } = {};

  @Output() editChange: EventEmitter<any> = new EventEmitter<any>();

  filterOptionList = ['All', 'Department', 'Location'];

  public searchText: string;

  public selectedFilter = 'All';

  public selectedSubFilter: string;

  public requestInProgress = false;

  constructor(
    private errorHandler: ErrorHandler,
    private catalogService: CatalogService,
    private toastr: ToastrService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.readPostedJobs();
  }

  public readPostedJobs() {
    const obj = {};
    this.requestInProgress = true;
    this.catalogService.getCareerJobs(obj).subscribe(
      (response) => {
        if (response.status === 0) {
          this.materPostedJobList = response.data.careerJobs;
          this.postedJobList = [...this.materPostedJobList];
          this.locations = [];
          this.departments = [];
          const locationMap: { [key: string]: string } = {};
          const departmentMap: { [key: string]: string } = {};
          this.materPostedJobList.forEach((j) => {
            if (j.department && !departmentMap[j.department]) {
              this.departments.push(j.department);
              departmentMap[j.department] = j.department;
            }

            if (j.location && !locationMap[j.location]) {
              this.locations.push(j.location);
              locationMap[j.location] = j.location;
            }
          });
        }
        this.requestInProgress = false;
      },
      (error) => {
        this.toastr.error(error.errorMessage);
        this.requestInProgress = false;
      }
    );
  }

  public jobEdit(job: JobData) {
    this.editChange.emit(job);
    this.scrollTop();
  }

  public onActivateJob(job: JobData) {
    job.isActive = true;
    this.updateJob(job, false);
    
  }

  public onDeactivateJob(job: JobData) {
    job.isActive = false;
    this.updateJob(job, true);

  }

  public updateJob(job: JobData, originalState: boolean){
    this.catalogService.addOrUpdateCareer(job).subscribe(
      (response) => {
        if (response.status === 0) {
          this.toastr.success(response.message);
        } else{
          job.isActive = originalState;
          this.errorHandler.handleError(response);
        }
        
      },
      (error) => {
        job.isActive = originalState;
        this.errorHandler.handleError(error);
      }
    );
  }

  public scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  public openDialog(job: JobData) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      height: '207px',
      width: '486px',
      data: { value: job , mode: 'DELETE'},
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.status) {
        this.requestInProgress = true;
        this.catalogService.deleteCareerJob({ id: result.data.id }).subscribe(
          (response) => {
            if (response.status === 0) {
              this.toastr.success(response.message);
              this.readPostedJobs();
            } else {
              this.toastr.error(response.error.errorMessage);
            }
            this.requestInProgress = false;
          },
          (error) => {
            this.toastr.error(error.errorMessage);
            this.requestInProgress = false;
          }
        );
      }
    });
  }

  public onChangeSubFilter(change: MatSelectChange) {
    const value = change.value;
    if (value) {
      if (this.selectedFilter === 'Department') {
        this.postedJobList = this.materPostedJobList.filter(
          (j) => j.department === this.selectedSubFilter
        );
      } else {
        this.postedJobList = this.materPostedJobList.filter(
          (j) => j.location === this.selectedSubFilter
        );
      }
    } else {
      this.postedJobList = [...this.materPostedJobList];
    }
  }
}
